/**
 * Shared styles and small helpers for Custom Tools UI (form, import, lists).
 */

import React from 'react'

export const customToolFormInputClass =
  'tw-w-full tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-gray-900 tw-placeholder-gray-400 tw-outline-none focus:tw-border-blue-500 focus:tw-ring-2 focus:tw-ring-blue-500/20 tw-transition-all'

export const customToolFormSelectClass =
  'tw-w-full tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-gray-900 tw-outline-none focus:tw-border-blue-500 focus:tw-ring-2 focus:tw-ring-blue-500/20 tw-transition-all tw-appearance-none tw-cursor-pointer'

export const customToolFormLabelClass =
  'tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wide tw-mb-1.5'

/** HTTP method badge colors (background + text + ring) for tool rows and similar. */
export const customToolHttpMethodColors: Record<string, string> = {
  GET: 'tw-bg-emerald-50 tw-text-emerald-700 tw-ring-emerald-600/20',
  POST: 'tw-bg-blue-50 tw-text-blue-700 tw-ring-blue-600/20',
  PUT: 'tw-bg-amber-50 tw-text-amber-700 tw-ring-amber-600/20',
  PATCH: 'tw-bg-orange-50 tw-text-orange-700 tw-ring-orange-600/20',
  DELETE: 'tw-bg-red-50 tw-text-red-700 tw-ring-red-600/20',
}

type AuthValuesUpdater = React.Dispatch<React.SetStateAction<Record<string, string>>>

/**
 * Reusable controlled inputs for bearer/basic/oauth blocks (same shape in form + import).
 */
export function useCustomToolAuthFields(
  values: Record<string, string>,
  setValues: AuthValuesUpdater,
) {
  const authField = (placeholder: string, key: string, type: 'text' | 'password' = 'text') => (
    <input
      type={type}
      className={customToolFormInputClass}
      placeholder={placeholder}
      value={values[key] || ''}
      onChange={(e) => setValues((prev) => ({ ...prev, [key]: e.target.value }))}
    />
  )
  return { authField }
}
